import * as $ from 'jquery';
import 'bootstrap';
import 'MagnificPopup';
import * as Cookies from 'js-cookie';
import { siteGeneral } from "./site";

export class mobileAppWidget{
	private site = new siteGeneral();

	$scope: any = $('.mobileapp');
	$scope1: any = $('#mobileapp-popup');
	

	$mobileAppSubmitYesBtn: any = $('.app-yes--btn');

	mobileAppPopUpInit(): void {
		let _self = this;
		let $screenSize:any = $(window).width();
		let userAgent:any = navigator.userAgent || navigator.vendor;

		if($screenSize < 768) {
			if (!Cookies.get('mobileapp-closed')) {
				_self.$scope.delay(1500).fadeIn(600);
			}
			if (_self.site.sessionStorage() && !sessionStorage.getItem('mobileapp-popup-closed') && userAgent.match( /Android/i )) {
				_self.$scope1.delay(2000).fadeIn(600);
				
			}
			else{
				$.magnificPopup.close();
				_self.$scope1.fadeOut(600);
			}

		}


	  if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) )
	  {
	  	let $iosAppStoreLink:any = _self.$scope.attr('data-mobileapp-ios');
	    _self.$mobileAppSubmitYesBtn.attr('href', $iosAppStoreLink);
	  }
	  else if( userAgent.match( /Android/i ) )
	  {

	  	let $androidPlayStoreLink:any = _self.$scope.attr('data-mobileapp-android');
		_self.$mobileAppSubmitYesBtn.attr('href', $androidPlayStoreLink);
		// Task 8590 code starts 
		let checkfor_newsletter_popup = $.magnificPopup.instance.isOpen;
		if ((_self.site.sessionStorage() && !sessionStorage.getItem('mobileapp-popup-closed')) && !(checkfor_newsletter_popup)) {
		$.magnificPopup.open({
			items: {
				src: '#mobileapp-popup'
			},
			type: 'inline',
			midClick: true,
			enableEscapeKey: false,
			showCloseBtn: false,
			closeOnBgClick: false,
			callbacks: {
				open: function () {
					var mobileappDealsCookie = document.cookie.match('(^|;)\\s*mobileappDealsCookie\\s*=\\s*([^;]+)');
					if(mobileappDealsCookie !=null){ console.log(1);
						var magnificPopup = $.magnificPopup.instance; 
						magnificPopup.close(); 	
					}	
				},
				close: function () {
					$('body').css('overflow', '');
					$('body').css('height', '');

				}
			}
		}, 0);
	  }
		
	}
	  let $closeApppopup:any = $('.mobile-popup--close');
	  $closeApppopup.on('click', function(){
	  	if (_self.site.sessionStorage()) {
		  	sessionStorage.setItem('mobileapp-popup-closed', '1');
		  }
		  $.magnificPopup.close();
	  	_self.$scope1.fadeOut(600);
	  });	// Task 8590 code ends 

	  let $closeApp:any = $('.mobile-app--close .fa');
	  $closeApp.on('click', function(){
	  	if (!Cookies.get('mobileapp-closed')) {			  
			  Cookies.set('mobileapp-closed', true, {expires: 7});
	  	}
	  	_self.$scope.fadeOut(600);
	  });

	  $('.app-yes--btn , .mobile-popup--close').on('click', function(){
		var CookieDate = new Date;
		CookieDate.setFullYear(CookieDate.getFullYear() +1);
	
		document.cookie = "mobileappDealsCookie=false" + ";expires=" + CookieDate.toUTCString()+ ";path=/";
	  });

	}
}

let scope:Element = document.querySelector('.mobileapp');
if (scope){
	try {
		let mobileappwidget = new mobileAppWidget();
		mobileappwidget.mobileAppPopUpInit();
	} catch(e) {console.error(e);}
}
	// Task 8590 code starts 
let scope1:Element = document.querySelector('#mobileapp-popup');
if (scope1){
	try {
		let mobileappwidget = new mobileAppWidget();
		mobileappwidget.mobileAppPopUpInit();
	} catch(e) {console.error(e);}
}
	// Task 8590 code ends here
